import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route } from 'react-router-dom';
import AuthLayout from 'container/authentication/index';

const Login = lazy(() => import('container/authentication/overview/signIn'));

const FrontendRoutes = () => {
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route exact path="/" component={Login} />
      </Suspense>
    </Switch>
  );
};

export default AuthLayout(FrontendRoutes);
